<template>
  <div id="sre-support-platform">
    <h2>支持平台</h2>
    <p>支持一键导入阿里云、京东云、Azure、AWS、Openstack云资源平台，其他云资源可通过独立云环境导入。</p>
    <ul>
      <li v-for="item in data" :class="{'active':active==item.id+1}" :key="item.id">
        <img :src="item.src" />
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'SreSupportPlatform',
    data() {
      return {
        active: 0,
        data: [{
            id: 0,
            src: require('@/assets/images/aliyun.png')
          }, {
            id: 1,
            src: require('@/assets/images/jingdongyun.png')
          },
          {
            id: 2,
            src: require('@/assets/images/azure.png')
          },
          {
            id: 3,
            src: require('@/assets/images/aws.png')
          }, {
            id: 4,
            src: require('@/assets/images/openstack.png')
          }
        ]
      }
    },
    methods: {
      activeMe(index) {
        this.active = index
      }
    }
  }
</script>

<style>
  @media(min-width:992px) {
    #sre-support-platform {
      width: 100%;
      height: 400px;
      background-color: #F1F7FF;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }

    #sre-support-platform h2 {
      font-size: 36px;
      font-family: SimHei;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      margin-top: 79px;
    }

    #sre-support-platform p {
      font-size: 18px;
      font-family: SimHei;
      font-weight: 400;
      color: rgba(68, 68, 68, 1);
      margin: 37px 0 59px;
    }

    #sre-support-platform ul {
      display: flex;
      justify-content: space-between;
      width: 75%;
      height: 89px;
    }

    #sre-support-platform ul li {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width:19%;
      height: 100%;
      background: rgba(220, 229, 252, 1);
      border: 2px solid rgba(220, 229, 252, 1);
      border-radius: 2px;
      transition: .6s;
      -moz-transition: .6s;
      -webkit-transition: .6s;
      -moz-transition: .6s;
    }

    #sre-support-platform ul li:hover {
      background: rgba(0, 235, 246, 0.1);
      border: 2px solid #00EBF6;
    }
  }

  @media(max-width:992px) {
    #sre-support-platform {
      width: 100%;
      background-color: #F1F7FF;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }

    #sre-support-platform h2 {
      font-size: 0.2rem;
      font-family: SimHei;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      margin-top: 35px;
    }

    #sre-support-platform p {
      font-size: 0.12rem;
      line-height: 1.1;
      font-family: SimHei;
      font-weight: 400;
      color: rgba(68, 68, 68, 1);
      margin: 0.37rem 0 0.59rem;
    }

    #sre-support-platform ul {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      width: 90%;
      margin-bottom: 0.2rem;
    }

    #sre-support-platform ul li {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      background: rgba(220, 229, 252, 1);
      border: 0.01rem solid rgba(220, 229, 252, 1);
      border-radius: 2px;
      transition: .6s;
      -moz-transition: .6s;
      -webkit-transition: .6s;
      -moz-transition: .6s;
      margin-bottom: 0.05rem;
    }

    #sre-support-platform ul li img {
      width: 50%;
    }

    #sre-support-platform ul li.active {
      background: rgba(0, 235, 246, 0.1);
      border: 0.01rem solid #00EBF6;
    }
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/SreSupportPlatform.vue